<template>
  <Card
    title="Location Info"
    direction="column"
    color="background"
    background="magenta"
  >
    <Stack
      direction="column"
      spacing="none"
    >
      <TextComponent color="background" type="heading4" as="p">
        Address
      </TextComponent>
      <TextComponent color="background" type="body1">
        {{
          `${data.hackerApplication.city}, ${data.hackerApplication.province}`
        }}
      </TextComponent>
      <TextComponent color="background" type="body1">
        {{ data.hackerApplication.country || 'undefined' }}
      </TextComponent>
    </Stack>

    <TextComponent color="background" type="body1">
      Shirt Size: {{ data.hackerApplication.shirtSize || 'undefined' }}
    </TextComponent>
  </Card>
</template>

<script>
  import Stack from '@hackthe6ix/vue-ui/Stack';
  import TextComponent from '@hackthe6ix/vue-ui/Text';
  import Card from '../../../../containers/Card';

  export default {
  name: 'LocationInfo',
  components: {
    TextComponent,
    Stack,
    Card,
  },
  props: {
    data: Object,
  },
};
</script>
